import { Center, Stack, Text, Title, useMantineTheme } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import React from 'react'

import RootButton from './Buttons/RootButton'
import styles from './MaintenancePage.module.css'

const MaintenancePage: React.FC = () => {
  const theme = useMantineTheme()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`)

  return (
    <Center>
      <Stack className={styles.pageTile}>
        <Title order={isMobile ? 3 : 2}>Under Maintenance</Title>
        <Stack gap="30px">
          <Text
            className={styles.pageText}
            style={{
              fontSize: isMobile ? '20px' : '34px',
            }}
          >
            We&apos;re sorry, but this LAMINA1 Hub web app is currently under maintenance.
          </Text>
          <RootButton onClick={() => window.open('https://lamina1.com', '_blank')}>
            Visit Mainnet Hub
          </RootButton>
        </Stack>
      </Stack>
    </Center>
  )
}

export default MaintenancePage
